module.exports = __webpack_public_path__ + "static/media/green-design-bg.10ef404e.png";